import React, { useState, useEffect } from 'react';
import styles from './Stepper.module.css';

const Stepper = React.memo(function Stepper({ currentStep, totalSteps, stepsName }) {
  const [isMounted, setIsMounted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    setIsMounted(true);
    
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const steps = Array.from(
    { length: totalSteps },
    (_, i) => ({ number: i + 1, label: stepsName[i] || '' })
  );

  // Don't render anything until we know the screen size
  if (!isMounted) {
    return (
      <div className={styles.stepperPlaceholder}>
        {/* Optional: Add a subtle loading state that matches your design */}
        <div style={{ height: '60px', width: '100%' }}></div>
      </div>
    );
  }

  // For mobile: render simple progress bar
  if (isMobile) {
    const progressPercentage = (currentStep / totalSteps) * 100;
    
    return (
      <div className={styles.mobileProgressContainer}>
        <div className={styles.mobileProgressBackground}>
          <div 
            className={styles.mobileProgressFill}
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    );
  }

  // Check if current step is fractional (halfway point)
  const isFractional = currentStep % 1 !== 0;
  const currentStepFloor = Math.floor(currentStep);

  return (
    <div className={styles.progressBar}>
      {steps.map((step, index) => {
        // Determine step state based on fractional currentStep
        let stepState = 'inactive';
        if (isFractional) {
          if (step.number <= currentStepFloor) {
            stepState = 'completed';
          }
        } else {
          if (step.number === currentStep) {
            stepState = 'active';
          } else if (step.number < currentStep) {
            stepState = 'completed';
          }
        }

        // Determine line state
        let lineState = 'lineInactive';
        if (isFractional) {
          if (step.number < currentStepFloor) {
            lineState = 'lineCompleted';
          } else if (step.number === currentStepFloor) {
            lineState = 'lineHalfway';
          }
        } else {
          if (step.number < currentStep) {
            lineState = 'lineCompleted';
          }
        }

        return (
          <div key={index} className={styles.stepContainer}>
            <div
              className={`${styles.step} ${
                stepState === 'active'
                  ? styles.active
                  : stepState === 'completed'
                  ? styles.completed
                  : styles.inactive
              }`}
            >
              {step.number}
            </div>

            {index < steps.length - 1 && (
              <div
                className={`${styles.line} ${
                  lineState === 'lineCompleted' 
                    ? styles.lineCompleted 
                    : lineState === 'lineHalfway'
                    ? styles.lineHalfway
                    : styles.lineInactive
                }`}
              />
            )}

            <div
              className={`${styles.label} ${
                stepState === 'active'
                  ? styles.labelActive
                  : stepState === 'completed'
                  ? styles.labelCompleted
                  : styles.labelInactive
              }`}
            >
              {step.label}
            </div>
          </div>
        );
      })}
    </div>
  );
});

export default Stepper;